import { render, staticRenderFns } from "./LevelReviewHomeWorksManager.vue?vue&type=template&id=03d479c4&"
import script from "./LevelReviewHomeWorksManager.vue?vue&type=script&lang=ts&"
export * from "./LevelReviewHomeWorksManager.vue?vue&type=script&lang=ts&"
import style0 from "./LevelReviewHomeWorksManager.vue?vue&type=style&index=0&id=03d479c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports